.date-picker {
  display: flex;
  input {
    height: 24px;
  }
  button {
    display: block;
    height: 24px;
  }
}
